(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-file-types', {
            parent: 'entity',
            url: '/tab-file-types',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.tabFileTypes.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-file-types/tab-file-types.html',
                    controller: 'TabFileTypesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                itemsPerPageChosen: null,
                sort: {
                    value: [],
                    squash: true
                },
                predicates: {},
                search: {
                    value: '',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        predicates: $stateParams.predicates,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabFileTypes');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-file-types-new', {
            parent: 'tab-file-types',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.tabFileTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-file-types/tab-file-types-dialog.html',
                    controller: 'TabFileTypesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabFileTypes');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        id: null
                    };
                }
            }
        })
            .state('tab-file-types-edit', {
                parent: 'tab-file-types',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFileTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-file-types/tab-file-types-dialog.html',
                        controller: 'TabFileTypesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFileTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFileTypes', function($stateParams, TabFileTypes) {
                        return TabFileTypes.get({id : $stateParams.id});
                    }]
                }
            })
            .state('tab-file-types.delete', {
                parent: 'tab-file-types',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-file-types/tab-file-types-delete-dialog.html',
                        controller: 'TabFileTypesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFileTypes', function(TabFileTypes) {
                                return TabFileTypes.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('tab-file-types', null, { reload: true });
                    }, function() {
                        $state.go('tab-file-types');
                    });
                }]
            });
    }

})();
